//import Vue from "vue";
import AnswerDTO from '@/Mixins/BaseInformation/ChiefComplaint/dto/Answer.dto';
import QuestionDTO from '@/Mixins/BaseInformation/ChiefComplaint/dto/Question.dto';
import PageTitleHelper from '@/Helpers/pageTitle.helper';

export default {
  data() {
    return {
      formErrors: {},
      formLoad: false,
      isMissionRankModalOpen: false,
      missionRankModalType: 0,
      missionPhoneId: null,
      phoneId: null,
      selectedVehicleType: null,
      selectedVehicleTypeCount: null,
      listOfSelectedCodes: [],
      doesTechnicianRequestPaitentLocation: false,
      genaralTriage: {},
      generalTriageCounter: null,
      genaralTriageMap: [],
      triage: {},
      triageMap: [],
      triageCounter: 0,
      sendLocationSMS: false,
      historyData: {},
      confirmType: 0,
      selectedChiefComplaint: null,
      selectedCity: null,
      selectedNurseDesition: this.$store,
      complaintNote: '',
      complaintAddress: '',
      acceptLocation: false,
      patientFirstName: '',
      patientLastName: '',
      patientGender: null,
      patientRelation: '',
      patientAgeYear: '',
      patientAgeMonth: '',
      patientAgeDay: null,
      isPatientNewBorn: false,
      patientNationalCode: '',
      compliantRecoveryPhone: '',
      compliantHasDoctorConsultant: false,
      compliantPostalCode: '',
      missionCreationType: null,
      missionInformTypeId: null,
      compliantTag: [],
      compliantOtherOrganizations: [],
      compliantMoreInformationNote: '',
      compliantClinicalTriageList: [],
      selectedCompliantClinicalTriageList: [],
      callerHistoryInFormList: [],
      callerHistoryInFormListHeader: [
        { text: 'تاریخ', value: 'creationDate', align: 'right' },
        { text: 'شکایت', value: 'chiefComplaintTitle', align: 'right' },
        { text: 'نتیجه', value: 'result', align: 'right' },
        { text: 'آدرس', value: 'address', align: 'right' },
        { text: '', value: 'actions', align: 'center' },
      ],
      callerLocation: null,
      locationCounter: 1,
      searchCurrentMission: '',
      onlineMissionListHeader: [
        {
          text: 'شکایت',
          value: 'chiefComplaintTitle',
          align: 'right',
          width: '150',
        },
        { text: 'آدرس', value: 'address', align: 'right' },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          width: '120',
        },
        { text: 'کد', value: 'code', align: 'right', width: '100' },


      ],
      onlineMissionList: [],
      showGeneralTriage: true,
      showTriage: false,
      lastGeneralTriageHint: '',
      lastTriageHint: '',
      mapGeoAddress: '',
      searchGeoLocationText: '',
      passedTime: 0,
      passedTimeInterval: null,
      showPassedTime: null,
      numberOfPatients: 1,
      missionType: '',
      isFinalize: false,
      missionRank: null,
      rankToolTip: 'عدم اعزام',
      rankIconColor: '#212121',
      rankIconClass: 'mt-1',
      rankIconInterval: '',
      rankAlarmAnimation: 1,
      endCallTagsList: [],
      callTagId: null,
      mainMissionId: null,
      missionId: null,
      attachmentModal: false,
      attachmentModalTitle: '',
      attachmentCurrentMissionListHeader: [
        { text: '', value: 'check', align: 'right' },
        { text: 'کد', value: 'code', align: 'right' },
        {
          text: 'تشخیص',
          value: 'chiefComplaintTitle',
          align: 'right',
          width: '200',
        },
        { text: 'آدرس', value: 'address', align: 'right' },
      ],
      triageBaliniModal: false,
      headerBackgroundClass: '',
      latLngForShow: '',
      setAddressIconColor: '#757575',
      setAddressIconColorInterval: null,
      dndDurationInterval: null,
      dndDuration: null,
      dndTime: 0,
      isDND: false,
      hasDnd: false,
      typingTimer: '',
      doneTypingInterval: 2000,
      suggestCodeModal: false,
      endDNDNoteModal: false,
      endDNDNote: '',
      endDNDType: '',
      searchTextAttachment: '',
    };
  },
  mixins: [QuestionDTO, AnswerDTO, PageTitleHelper],
  methods: {
    setMissionRankBaseOnTriageAnswers: function (value) {
      const redRank = [...value]?.some(({ rank }) => rank === 3);
      const yellowRank = [...value]?.some(({ rank }) => rank === 2);
      const greenRank = [...value]?.some(({ rank }) => rank === 1);
      const whiteRank = [...value]?.some(({ rank }) => rank === 0);
      if (value?.length === 0) {
        this.missionRank = null;
        return;
      }
      if (redRank) {
        this.missionRank = 3;
        return;
      }
      if (yellowRank) {
        this.missionRank = 2;
        return;
      }
      if (greenRank) {
        this.missionRank = 1;
        return;
      }
      if (whiteRank) {
        this.missionRank = 0;
        return;
      }
    },
    openMissionRankModal: function (type) {
      this.isMissionRankModalOpen = true;
      this.missionRankModalType = type;
    },
    closeMissionRankModal: function () {
      this.isMissionRankModalOpen = false;
      this.missionRankModalType = -1;
    },
    onMissionRankSetAccept: function () {
      switch (this.missionRankModalType) {
        case 0:
          this.sendConsultCall();
          break;

        default:
          break;
      }
      this.closeMissionRankModal();
    },
    showConsultConfirmDialog: function (id, attachable) {
      this.confirmType = 0;
      this.selectedEndCallId = id;
      this.selectedEndCallAttachable = attachable;
      if (this.setModalTexts(id)) {
        this.$refs.confirm.showConfirmDialog = true;
        requestAnimationFrame(() => {
          if (this.$refs.yes) {
            this.$refs.yes.$el.focus();
          }
        });
      } else if (id === 2) this.openMissionRankModal(0);
      else this.checkEndCallType(id, attachable);
    },
    toggleTimer: function () {
      this.passedTimeInterval = setInterval(this.incrementTime, 1000);
    },
    incrementTime: function () {
      this.passedTime = parseInt(this.passedTime) + 1;
      this.showPassedTime = new Date(this.passedTime * 1000).toISOString().substring(14, 19);
    },
    closeNewHandleForm: function () {
      this.cleanForm();
      this.changeToOldTitle();
      if (this.type == "hand") {
        this.$root.$refs.Home.closeForm(this.uniqueId);
      }
    },
    scrollTo: function (type) {
      if (type == 'generalQuestion') {
        document.getElementById('generalQuestion').scrollIntoView({ behavior: 'smooth' });
      } else if (type == 'mainInformation') {
        document.getElementById('mainInformation').scrollIntoView({ behavior: 'smooth' });
      } else if (type == 'phoneTriage') {
        document.getElementById('phoneTriage').scrollIntoView({ behavior: 'smooth' });
      } else if (type == 'scrollMap') {
        document.getElementById('scrollMap').scrollIntoView({ behavior: 'smooth' });
      } else if (type == 'otherInformation') {
        document.getElementById('otherInformation').scrollIntoView({ behavior: 'smooth' });
      } else if (type == 'clinicalTriage') {
        document.getElementById('clinicalTriage').scrollIntoView({ behavior: 'smooth' });
      }
    },
    checkRankForColor: function (rank) {
      if (rank == 0) {
        return '#F4F4F4';
      } else if (rank == 1) {
        return '#A4FFCB';
      } else if (rank == 2) {
        return '#FFE290';
      } else if (rank == 3) {
        return '#FFAFAF';
      }
    },
    addCodeForMission: function () {
      if (!this.selectedVehicleType) {
        this.snackText = 'لطفا نوع کد را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (
        this.selectedVehicleTypeCount === null ||
        this.selectedVehicleTypeCount === undefined ||
        this.selectedVehicleTypeCount === ''
      ) {
        this.snackText = ' لطفا تعداد ' + this.selectedVehicleType.title + ' را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.listOfSelectedCodes.length > 0) {
        for (let i = 0; i < this.listOfSelectedCodes.length; i++) {
          if (this.listOfSelectedCodes[i].id == this.selectedVehicleType.id) {
            this.snackText = ' کد ' + this.selectedVehicleType.title + ' قبلا انتخاب شده است';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            return;
          }
        }
      }
      this.listOfSelectedCodes.push({
        title: this.selectedVehicleType.title,
        count: this.selectedVehicleTypeCount,
        id: this.selectedVehicleType.id,
      });
      this.selectedVehicleType = null;
      this.selectedVehicleTypeCount = null;
    },
    removeCodeFromMission: function (id) {
      for (let i = 0; i < this.listOfSelectedCodes.length; i++) {
        if (this.listOfSelectedCodes[i].id == id) {
          this.listOfSelectedCodes.splice(i, 1);
        }
      }
    },
    enableGeneralTriageMap: function () {
      this.showGeneralTriage = true;
    },
    closeGeneralTriageMap: function () {
      this.showGeneralTriage = false;
    },
    enableTriageMap: function () {
      this.showTriage = true;
    },
    closeTriageMap: function () {
      this.showTriage = false;
    },
    goToSpecialQuestion: function (data) {
      this.triage = data;
    },
    // set technician request paitent location
    setTechnicianRequestPaitentLocation: function (value) {
      this.doesTechnicianRequestPaitentLocation = value;
    },

    onSettingTechnicianRequestPaitentLocation: function () {
      this.setTechnicianRequestPaitentLocation(true);
    },
    setGeoAddressForMainAddress: function () {
      clearInterval(this.setAddressIconColorInterval);
      this.setAddressIconColorInterval = null;
      this.setAddressIconColor = '#46BA50';
      this.complaintAddress = this.mapGeoAddress;
    },
    //map
    searchForGeoLocation: function () {
      if (this.searchGeoLocationText) {
        this.getMapGeoCode(this.searchGeoLocationText);
      }
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 16);
    },
    setAddress: function (text) {
      this.mapGeoAddress = text;
    },
    goToSpecialGeneralQuestion: function (data) {
      if (this.genaralTriageMap[this.genaralTriageMap.length - 1].answerColor == '#F4F4F4') {
        this.genaralTriageMap.splice(this.genaralTriageMap.length - 1, 1);
        this.genaralTriage = data.fullTriageItem;
        this.genaralTriageMap.push({
          questionId: data.questionId,
          questionTag: data.questionTag ? data.questionTag : '-',
          answerColor: '#F4F4F4',
          fullTriageItem: data.fullTriageItem,
        });
      } else {
        this.genaralTriage = data.fullTriageItem;
        this.genaralTriageMap.push({
          questionId: data.questionId,
          questionTag: data.questionTag ? data.questionTag : '-',
          answerColor: '#F4F4F4',
          fullTriageItem: data.fullTriageItem,
        });
      }
    },
    chiefComplaintChange: function (item) {
      this.handleErrorComplaintInput("nurseDesition");
      this.selectedNurseDesition = item;
      if (this.selectedNurseDesition) {
        if (this.selectedNurseDesition.id) {
          this.getTriageQuestionWithChiefComplaintFunction(this.selectedNurseDesition.id);
        }
      }
    },
    changeTriageFromDiagnosis: function (temp) {
      if (this.genaralTriageMap[this.genaralTriageMap.length - 1].answerColor == '#F4F4F4') {
        this.genaralTriageMap.splice(this.genaralTriageMap.length - 1, 1);
        this.genaralTriageMap.push({
          questionId: temp.id,
          questionTag: temp.tag ? temp.tag : '-',
          answerColor: '#F4F4F4',
          fullTriageItem: {},
        });
        let hasChiefComlaint = false;
        if (temp.chiefComplaint) {
          hasChiefComlaint = true;
        }
        this.genaralTriage = {
          questionId: temp.id,
          questionTitle: temp.title,
          hasChiefComlaint: hasChiefComlaint,
          isGeneral: temp.isGeneral,
          answers: [],
        };
        if (temp.triageAnswers) {
          for (let i = 0; i < temp.triageAnswers.length; i++) {
            let color = '#F4F4F4';
            if (temp.triageAnswers[i].rank !== null || temp.triageAnswers[i].rank !== undefined) {
              color = this.checkRankForColor(temp.triageAnswers[i].rank);
            }
            this.genaralTriage.answers.push({
              answerId: temp.triageAnswers[i].id,
              answerTitle: temp.triageAnswers[i].title,
              answerHint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
              answerRank: temp.triageAnswers[i].rank ? temp.triageAnswers[i].rank : null,
              color: color,
              hint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
            });
          }
        }
        this.genaralTriageMap[this.genaralTriageMap.length - 1].fullTriageItem = this.genaralTriage;
      } else {
        this.genaralTriageMap.push({
          questionId: temp.id,
          questionTag: temp.tag ? temp.tag : '-',
          answerColor: '#F4F4F4',
          fullTriageItem: {},
        });
        let hasChiefComlaint = false;
        if (temp.chiefComplaint) {
          hasChiefComlaint = true;
        }
        this.genaralTriage = {
          questionId: temp.id,
          questionTitle: temp.title,
          hasChiefComlaint: hasChiefComlaint,
          isGeneral: temp.isGeneral,
          answers: [],
        };
        if (temp.triageAnswers) {
          for (let i = 0; i < temp.triageAnswers.length; i++) {
            let color = '#F4F4F4';
            if (temp.triageAnswers[i].rank !== null || temp.triageAnswers[i].rank !== undefined) {
              color = this.checkRankForColor(temp.triageAnswers[i].rank);
            }
            this.genaralTriage.answers.push({
              answerId: temp.triageAnswers[i].id,
              answerTitle: temp.triageAnswers[i].title,
              answerHint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
              answerRank: temp.triageAnswers[i].rank ? temp.triageAnswers[i].rank : null,
              color: color,
              hint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
            });
          }
        }
        this.genaralTriageMap[this.genaralTriageMap.length - 1].fullTriageItem = this.genaralTriage;
      }
    },
    cityChange: function () {
      this.searchForLocation(this.selectedCity.title, this.selectedCity.province.title);
    },
    goToCityFromCity: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data[0].lat, data[0].lon], 12);
    },
    cleanForm: function () {
      this.formLoad = false;
      this.selectedVehicleType = null;
      this.selectedVehicleTypeCount = null;
      this.listOfSelectedCodes = [];
      this.genaralTriage = {};
      this.generalTriageCounter = null;
      this.genaralTriageMap = [];
      this.triage = {};
      this.triageMap = [];
      this.triageCounter = 0;
      this.selectedChiefComplaint = null;
      this.selectedCity = null;
      this.selectedNurseDesition = null;
      this.complaintNote = '';
      this.complaintAddress = '';
      this.acceptLocation = false;
      this.patientFirstName = '';
      this.patientLastName = '';
      this.patientGender = null;
      this.patientRelation = '';
      this.patientAgeYear = '';
      this.patientAgeMonth = '';
      this.patientNationalCode = '';
      this.compliantRecoveryPhone = '';
      this.compliantHasDoctorConsultant = false;
      this.compliantPostalCode = '';
      this.missionCreationType = null;
      this.missionInformTypeId = null;
      this.setAddressIconColor = '#757575';
      clearInterval(this.setAddressIconColorInterval);
      this.setAddressIconColorInterval = null;
      this.compliantTag = [];
      this.compliantOtherOrganizations = [];
      this.compliantMoreInformationNote = '';
      this.compliantClinicalTriageList = [];
      this.callerHistoryInFormList = [];
      this.callerLocation = null;
      this.locationCounter = 1;
      this.searchCurrentMission = '';
      this.onlineMissionList = [];
      this.showGeneralTriage = false;
      this.showTriage = false;
      this.lastGeneralTriageHint = '';
      this.lastTriageHint = '';
      this.mapGeoAddress = '';
      this.searchGeoLocationText = '';
      this.passedTime = 0;
      clearInterval(this.passedTimeInterval);
      clearInterval(this.dndDurationInterval);
      this.dndDurationInterval = null;
      this.dndDuration = null;
      this.dndTime = 0;
      this.isDND = false;
      this.passedTimeInterval = null;
      this.showPassedTime = null;
      this.missionType = '';
      this.isFinalize = false;
      this.missionRank = 0;
      this.rankToolTip = 'عدم اعزام';
      this.rankIconColor = '#212121';
      this.rankIconClass = 'mt-1';
      this.rankIconInterval = '';
      this.rankAlarmAnimation = 1;
      this.endCallTagsList = [];
      this.callTagId = null;
      this.mainMissionId = null;
      this.missionId = null;
      this.latLngForShow = '';
    },
    showCurrentMissionAttachmentModal: function (id) {
      if (id == 4) {
        this.attachmentModalTitle = 'پیوست';
        this.callTagId = 4;
      } else if (id == 5) {
        this.attachmentModalTitle = 'پیگیری';
        this.callTagId = 5;
      }
      this.getListOfAttachmentMissionFunction();
      this.attachmentModal = true;
    },
    attachmentTableClick: function (data) {
      let temp = this.allAttachment;
      this.allAttachment = [];
      temp.forEach(element => {
        if ((element?.missionId == data.missionId && element.check == true) || element?.missionId != data.missionId) {
          element.check = false
        } else {
          this.mainMissionId = data.missionId;
          element.check = true
        }
      });

      // for (let i = 0; i < temp.length; i++) {
      //   if (temp[i].missionId != data.missionId) {
      //     temp.check = false;
      //   } else {
      //     temp.check = true;
      //     this.mainMissionId = data.missionId;
      //   }
      // }

      this.allAttachment = [...temp];
    },

    cancelAttachment: function () {
      this.mainMissionId = null;
      this.allAttachment.forEach((c) => (c.check = false));
      this.allAttachment = [];
      this.attachmentModal = false;
    },
    showEdit115MissionModal: function (_, data) {
      try {
        this.missionPhoneId = data.item.missionPhoneId;
        this.phoneId = data.item.phoneId;
        this.missionId = data.item.missionId;
        this.currentMissionModal = true;
      } catch (error) {
        console.log("error : ", error);
      }
    },
    cancleTriageBaliniModal: function () {
      this.triageBaliniModal = false;
    },
    showTriageBaliniModal: function () {
      if (this.selectedNurseDesition && this.selectedNurseDesition.id) {
        for (let i = 0; i < this.compliantClinicalTriageList.length; i++) {
          for (let j = 0; j < this.selectedCompliantClinicalTriageList.length; j++) {
            if (
              this.compliantClinicalTriageList[i].id ==
              this.selectedCompliantClinicalTriageList[j].id
            ) {
              this.compliantClinicalTriageList[i].isDisable = true;
              this.compliantClinicalTriageList[i].isSelected = true;
            }
          }
        }
        this.triageBaliniModal = true;
      } else {
        this.snackText = 'لطفا تشخیص احتمالی پرستار را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
    },
    changeSetAddressIcon: function () {
      this.setAddressIconColorInterval = setInterval(() => {
        if (this.setAddressIconColor == '#46BA50') {
          this.setAddressIconColor = '#757575';
        } else {
          this.setAddressIconColor = '#46BA50';
        }
      }, 500);
    },
    async startDNDTime() {
      if (this.dndDurationInterval) {
        clearInterval(this.dndDurationInterval);
        this.dndDurationInterval = null;
      }

      this.$store.dispatch('getUserCurrent').then(() => {
        if (this.$store.state.userModule.successFlag) {
          let data = this.$store.state.userModule.user;
          if (data.currentExtension) {
            this.isDND = data.currentExtension.isDND;
            if (this.isDND) {
              // this.$root.$refs.Home.startDNDHome('newCall');
              // let now = new Date();
              // let diffTime = now.getTime() - new Date(data.currentExtension.startDateDND).getTime();
              // this.dndDuration = this.msToTime(diffTime);
              // this.dndDurationInterval = setInterval(() => {
              //   diffTime = diffTime + 1000;
              //   this.dndDuration = this.msToTime(diffTime);
              // }, 1000);


              const startTime = new Date(data.currentExtension.startDateDND).getTime();

              this.dndDuration = this.msToTime(Date.now() - startTime);

              this.dndDurationInterval = setInterval(() => {
                this.dndDuration = this.msToTime(Date.now() - startTime);
              }, 1000);
              if (this.$root?.$refs?.Home?.startDNDHome) {
                this.$root.$refs.Home.startDNDHome('newCall');
              }

            }
          }
        }
      });
    },
    finishDNDTime: function () {
      this.endDNDNote = '';
      this.endDNDNoteModal = false;
      this.$store.dispatch('getUserCurrent').then(() => {
        if (this.$store.state.userModule.successFlag) {
          let data = this.$store.state.userModule.user;

          this.isDND = data?.currentExtension?.isDND ?? false;
          this.dndDuration = null;

          if (this.dndDurationInterval) {
            clearInterval(this.dndDurationInterval);
            this.dndDurationInterval = null;
          }

          if (this.$root?.$refs?.Home?.finishDNDHome) {
            this.$root.$refs.Home.finishDNDHome('newCall', this.endDNDNote);
          }
        }
      });
    },
    showDNDNoteModal: function (type) {
      // this.endDNDType = type;
      // this.endDNDNoteModal = true;
      if (this.$root?.$refs?.Home?.showDNDNoteModal) {
        this.$root.$refs.Home.showDNDNoteModal(type);
      }
    },
    setFinishDND: function () {
      if (!this.endDNDNote || !this.endDNDNote.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.disableUserDNDsnFunction(this.endDNDType, this.endDNDNote);
    },
    cancleDNDNoteModal: function () {
      this.endDNDType = '';
      this.endDNDNote = '';
      this.endDNDNoteModal = false;
    },
    // ثبت و فعال سازی
    checkForFinalizeMission: function (selectedQuestionsList = [], selectedAnswersList = []) {
      const questionIdsList = this.transformedAllSelectedQuestions(selectedQuestionsList);
      const answerIdsList = this.transformedAllSelectedAnswers(selectedAnswersList);

      this.finalizeMissionFuncion(questionIdsList, answerIdsList);
    },
    checkDnd: function () {
      let user = this.$store.state.userModule.user;
      if (user.currentExtension) {
        this.isDND = user.currentExtension.isDND;
        if (this.isDND) {
          //let startDate = Vue.moment(user.currentExtension.startDateDND).format("jYYYY/jM/jD HH:mm:ss");
          let now = new Date();
          let diffTime = now.getTime() - new Date(user.currentExtension.startDateDND).getTime();
          //let diffTime = now.diff(startDate);
          this.dndDuration = this.msToTime(diffTime);
          this.dndDurationInterval = setInterval(() => {
            diffTime = diffTime + 1000;
            this.dndDuration = this.msToTime(diffTime);
          }, 1000);
        }
      }
    },
    clearTimer: function () {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
    },
    typingClear: function () {
      clearTimeout(this.typingTimer);
    },
    doneTyping: function () {
      this.searchForGeoLocation();
    },
    ///NewValidateForm
    validateForm() {
      this.formErrors = {};

      if (!this.selectedCity || !this.selectedCity.id) {
        this.formErrors.city = "شهر اجباری است";
      } else if (!this.complaintAddress || this.complaintAddress.trim() === '') {
        this.formErrors.address = "آدرس فوریت اجباری است";
      } else if (!this.selectedChiefComplaint) {
        this.formErrors.chiefComplaint = "شکایت اصلی اجباری است";
      } else if (!this.selectedNurseDesition || !Number(this.selectedNurseDesition.id)) {
        this.formErrors.nurseDesition = "تشخیص /نوع حادثه اجباری است";
      } else if (typeof this.missionRank != "number") {
        this.formErrors.missionRank = "اولویت اجباری است";
      } else if (this.type === "hand" && (!this.compliantRecoveryPhone || this.compliantRecoveryPhone.trim() === '')) {
        this.formErrors.phone = "تلفن پیگیری اجباری است";
      }

      return Object.keys(this.formErrors).length === 0;
    },
    showSuggestCodeModal: function () {
      if (this.validateForm()) {
        this.suggestCodeModal = true;
      }
    },
    ///NewValidateForm
    sendTo800FromSuggestModal: function () {
      if (this.missionRank == null || this.missionRank == undefined) {
        this.showErrorAlert('الویت نمی تواند خالی باشد', 4000);
        return;
      }
      if (!this.selectedChiefComplaint) {
        this.snackText = 'شکایت اصلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedNurseDesition) {
        this.snackText = 'تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.selectedCity) {
        if (!this.selectedCity.id) {
          this.snackText = 'شهر نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else {
        this.snackText = 'شهر نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.complaintAddress) {
        this.snackText = 'آدرس نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.type == 'call') {
        if (!this.callerId) {
          this.snackText = 'تلفن اصلی نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (this.type == 'hand') {
        if (!this.compliantRecoveryPhone) {
          this.snackText = 'تلفن پیگیری نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      this.sendMissionToDispatchFuncion();
      this.suggestCodeModal = false;
    },
    cancleSuggestCodeModal: function () {
      if (this.listOfSelectedCodes.length == 0) {
        this.selectedVehicleType = null;
        this.selectedVehicleTypeCount = null;
      }
      this.suggestCodeModal = false;
    },
    setMissionInformationFromHistory: function (data) {
      this.selectedChiefComplaint = data?.chiefComplaintTitle;
      this.patientFirstName =
        data.missionCreationDetail && data.missionCreationDetail.firstName
          ? data.missionCreationDetail.firstName
          : '';
      this.patientLastName =
        data.missionCreationDetail && data.missionCreationDetail.lastName
          ? data.missionCreationDetail.lastName
          : '';
      this.patientAgeYear =
        data.missionCreationDetail && data.missionCreationDetail.ageYear
          ? data.missionCreationDetail.ageYear
          : '';
      this.patientAgeMonth =
        data.missionCreationDetail && data.missionCreationDetail.ageMonth
          ? data.missionCreationDetail.ageMonth
          : '';
      this.patientNationalCode =
        data.missionCreationDetail && data.missionCreationDetail.nationalCode
          ? data.missionCreationDetail.nationalCode
          : '';
      this.compliantPostalCode = data.postalCode ? data.postalCode : '';
      this.complaintAddress = data.address ? data.address : '';
      if (data.missionCreationDetail.gender == true) {
        this.patientGender = true;
      } else if (data.missionCreationDetail.gender == false) {
        this.patientGender = false;
      } else {
        this.patientGender = null;
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
  watch: {
    '$store.state.missionModule.currentNurseDiagnosis': function (currentVal) {
      if (currentVal?.id) this.selectedNurseDesition = currentVal;
    },
    '$store.state.missionModule.selectedAnswersFromTriage': {
      handler(currentValue) {
        this.setMissionRankBaseOnTriageAnswers(currentValue);
      },
      immediate: true,
    },

    // missionRank: function (currentVal) {
    //   if (currentVal === 3) this.showTostAlarm();
    // },
  },
};
